import InputFieldAttributes, { defineInputFieldPropsDefaults } from '@/mixins/InputFieldAttributes';
import type { InputFieldProps } from '@/mixins/InputFieldAttributes';

export type FormFieldPropsRules = Record<string, string | boolean | Array<any> | Record<string, any>>;
export type FormFieldPropsAutoCompleteOptionsType = 'POSTAL_CODE' | 'CITY' | 'STREET' | 'ADDRESS_LINE';
export type FormFieldPropsAutoCompleteOptions = { type: FormFieldPropsAutoCompleteOptionsType };

/**
 * Props for all form field components
 */
export type FormFieldProps = InputFieldProps & {
  rules?: FormFieldPropsRules;
  validationMode?: string;
  label?: string;
  floatLabel?: boolean;
  hideRequiredAsterix?: boolean;
  placeholder?: string;
  autoCompleteOptions?: FormFieldPropsAutoCompleteOptions | boolean;
  bypassSanitation?: boolean;
  expandedSanitation?: boolean;
  emitFocus?: boolean;
};

/**
 * Props for multi value form field components - like checkboxes, dropdown, selects etc.
 */
export type FormFieldPropsMulti = FormFieldProps & {
  options: Array<{ label: string; value?: string }>;
};

/**
 * Default values for props type 'FormFieldProps'
 */
export const defineFormFieldPropsDefaults = () => ({
  ...defineInputFieldPropsDefaults(),
  rules: (): FormFieldPropsRules => ({}),
  validationMode: 'eager',
  label: '',
  floatLabel: true,
  placeholder: '',
});

/**
 * Legacy mixin for options API form field components
 * @deprecated Should no longer be used and completely replaced by the composition API implementations above
 */
export default defineComponent({
  mixins: [InputFieldAttributes],
  props: {
    rules: {
      type: Object as PropType<FormFieldProps['rules']>,
      default: () => ({}),
    },
    validationMode: {
      type: String,
      default: 'eager',
    },
    label: {
      type: String,
      default: '',
    },
    floatLabel: {
      type: Boolean,
      default: true,
    },
    hideRequiredAsterix: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: '',
    },
    autoCompleteOptions: {
      type: [Object, Boolean] as PropType<FormFieldProps['autoCompleteOptions']>,
      default: false,
    },
    bypassSanitation: {
      type: Boolean,
    },
    expandedSanitation: {
      type: Boolean,
    },
  },
});
